import * as EWSAction from './action';
import { CORE_API, EWS_API } from '../../config';
import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants'
import request from "../../components/Utils/httpHelper";

export function* fetchEwsCounterpartiesList(action) {
    console.log("corp name SAGA called!");
    let requestURL = `${CORE_API}/portfolio/ews/counterparties?corpId=${action.data}`;
    try {
        const counterparties = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.fetchEwsCounterpartiesResponse(counterparties.data))
    }
    catch (err) {
        yield put(EWSAction.fetchEwsCounterpartiesResponse(err))
    }
}
export function* fetchEwsCounterparties() {
    yield takeLatest(EWSAction.FETCH_EWS_COUNTERPARTIES_REQUEST, fetchEwsCounterpartiesList);
}

export function* fetchFilteredEwsCounterpartiesList(action) {
    console.log("Filter SAGA Called!!!");
    let requestURL = `${CORE_API}/portfolio/ews/counterparties/filter`;
    try {
        const counterparties = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(EWSAction.fetchFilteredEwsCounterpartiesResponse(counterparties.data))
    }
    catch (err) {
        yield put(EWSAction.fetchFilteredEwsCounterpartiesResponse(err))
    }
}
export function* fetchFilteredEwsCounterparties() {
    yield takeLatest(EWSAction.FETCH_FILTERED_EWS_COUNTERPARTIES_REQUEST, fetchFilteredEwsCounterpartiesList);
}

export function* optInForEWS(action) {
    let requestUrl = `${CORE_API}/portfolio/ews/optin`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(EWSAction.optInForEwsResponse(createResult.data));
    } catch (err) {
        yield put(EWSAction.optInForEwsResponse(err))
    }
}
export function* ewsOptIn() {
    yield takeLatest(EWSAction.OPT_IN_FOR_EWS_REQUEST, optInForEWS);
}

export function* fetchEWSPlanList(action) {
    let requestUrl = `${EWS_API}/plan/all`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.ewsPlanListResponse(createResult.data));
    } catch (err) {
        yield put(EWSAction.ewsPlanListResponse(err))
    }
}
export function* ewsPlanList() {
    yield takeLatest(EWSAction.FETCH_EWS_PLAN_LIST_REQUEST, fetchEWSPlanList);
}

export function* fetchEWSPlan(action) {
    let requestUrl = `${EWS_API}/plan?planId=${action.data}`;
    try {
        const createResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.ewsPlanResponse(createResult.data));
    } catch (err) {
        yield put(EWSAction.ewsPlanResponse(err))
    }
}
export function* ewsPlan() {
    yield takeLatest(EWSAction.FETCH_EWS_PLAN_REQUEST, fetchEWSPlan);
}

export function* addEwsPlan(action) {
    let requestURL = `${EWS_API}/plan`;
    try {
        const data = yield call(request, requestURL, { data: action.data, method: 'POST', headers: HTTP_HEADERS });
        yield put(EWSAction.addEwsPlanResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.addEwsPlanResponse({ ...err.response, status: "FAILURE" }))
    }
}
export function* addPlan() {
    yield takeLatest(EWSAction.ADD_EWS_PLAN_REQUEST, addEwsPlan);
}

export function* downloadCPUploadTemplateRequest(action) {
    let requestURL = `${EWS_API}/counterparty/downloadTemplate`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.counterpartyUploadTemplateResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.counterpartyUploadTemplateResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* downloadCPUploadTemplate() {
    yield takeLatest(EWSAction.COUNTERPARTY_UPLOAD_TEMPLATE_REQUEST, downloadCPUploadTemplateRequest);
}

export function* counterpartyUploadRequest(action) {
    const headers = { ...HTTP_HEADERS };
    if (headers['Content-Type']) {
    delete headers['Content-Type'];
    }
    let requestURL = `${EWS_API}/counterparty/upload`;
    const formData = new FormData();
    formData.append('corporateId', action.data.corporateId);
    formData.append('corporateName', action.data.corporateName);
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: headers, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.counterpartyUploadResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.counterpartyUploadResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* counterpartyUpload() {
    yield takeLatest(EWSAction.COUNTERPARTY_UPLOAD_REQUEST, counterpartyUploadRequest);
}

export function* updatePlanInMappingRequest(action) {
    let requestURL = `${EWS_API}/counterparty/update/plan?corporateId=${action.data.corporateId}&counterpartyId=${action.data.counterpartyId}&planId=${action.data.planId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.updatePlanInMappingResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.updatePlanInMappingResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* updatePlanInMapping() {
    yield takeLatest(EWSAction.UPDATE_PLAN_IN_MAPPING_REQUEST, updatePlanInMappingRequest);
}

export function* crawlerStatusReportRequest(action) {
    let requestURL = `${EWS_API}/run/crawlerStatus?corporateId=${action.data.corporateId}&fromDate=${action.data.fromDate}&toDate=${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.fetchCrawlerStatusReportResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.fetchCrawlerStatusReportResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* crawlerStatusReport() {
    yield takeLatest(EWSAction.CRAWLER_STATUS_REPORT_REQUEST, crawlerStatusReportRequest);
}

export function* reinitiateFailedCrawlers(action) {
    let requestURL = `${EWS_API}/ews/reinitiateCrawlers`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA });
        yield put(EWSAction.reinitiateFailedCrawlersResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.reinitiateFailedCrawlersResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* reinitiateCrawlers() {
    yield takeLatest(EWSAction.REINITIATE_CRAWLERS_REQUEST, reinitiateFailedCrawlers);
}

export function* getDayOfMonthRequest(action) {
    let requestURL = `${EWS_API}/dayOfMonth`;
    try {
        const dom = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.getDayOfMonthResponse(dom.data))
    }
    catch (err) {
        yield put(EWSAction.getDayOfMonthResponse(err))
    }
}
export function* getDayOfMonth() {
    yield takeLatest(EWSAction.GET_DAY_OF_MONTH_REQUEST, getDayOfMonthRequest);
}

export function* updateDayOfMonthRequest(action) {
    let requestURL = `${EWS_API}/dayOfMonth/update`;
    try {
        const createResult = yield call(request, requestURL, { method: 'PUT', data: action.data, headers: HTTP_HEADERS });
        yield put(EWSAction.updateDayOfMonthResponse(createResult.data))
    }
    catch (err) {
        yield put(EWSAction.updateDayOfMonthResponse(err))
    }
}

export function* updateDayOfMonth() {
    yield takeLatest(EWSAction.UPDATE_DAY_OF_MONTH_REQUEST, updateDayOfMonthRequest);
}

export function* runEWSRequest(action) {
    let requestURL = `${EWS_API}/ews/run`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.runEWSResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.runEWSResponse({ ...err.response, status: "FAILURE" }))
    }
}
export function* runEWS() {
    yield takeLatest(EWSAction.RUN_EWS_REQUEST, runEWSRequest);
}

export function* ewsReportDataUploadTemplateRequest(action) {
    let requestURL = `${EWS_API}/ews/reportTemplate`;

    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.ewsReportDataUploadTemplateResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsReportDataUploadTemplateResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsReportDataUploadTemplate() {
    yield takeLatest(EWSAction.EWS_DATA_UPLOAD_TEMPLATE_REQUEST, ewsReportDataUploadTemplateRequest);
}

export function* ewsReportDataUploadRequest(action) {
    let requestURL = `${CORE_API}/ews/data/upload`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA});
        yield put(EWSAction.ewsReportDataUploadResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsReportDataUploadResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsReportDataUpload() {
    yield takeLatest(EWSAction.EWS_DATA_UPLOAD_REQUEST, ewsReportDataUploadRequest);
}

export function* corporateCounterpartyListRequest(action) {
    let requestURL = `${CORE_API}/ews/complete-data?fromDate=${action.data.fromDate}&toDate=${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.corporateCounterpartyListResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.corporateCounterpartyListResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* corporateCounterpartyList() {
    yield takeLatest(EWSAction.CORPORATE_COUNTERPARTY_LIST_REQUEST, corporateCounterpartyListRequest);
}

export function* publishDataRequest(action) {
    let requestURL = `${EWS_API}/publish/${action.data.publishId}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.getPublishDataResponse({ data: data.data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.getPublishDataResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* publishData() {
    yield takeLatest(EWSAction.GET_PUBLISH_DATA_REQUEST, publishDataRequest);
}

export function* ewsBulkOptinRequest(action) {
    let requestURL = `${EWS_API}/ews/bulkOptin`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA });
        yield put(EWSAction.ewsBulkOptinResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsBulkOptinResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsBulkOptin() {
    yield takeLatest(EWSAction.EWS_BULK_OPTIN_REQUEST, ewsBulkOptinRequest);
}

export function* createEWSPublishRequest(action) {
    let requestURL = `${EWS_API}/publish/create`;
    try {
        const data = yield call(request, requestURL, { method: 'POST', data: action.data, headers: HTTP_HEADERS });
        yield put(EWSAction.createEWSPublishResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.createEWSPublishResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* createEWSPublish() {
    yield takeLatest(EWSAction.CREATE_EWS_PUBLISH_REQUEST, createEWSPublishRequest);
}

export function* publishUnpublishEWSReportRequest(action) {
    let requestURL = `${EWS_API}/publish?publishId=${action.data.publishId}&isPublish=${action.data.isPublish}`;
    try {
        const data = yield call(request, requestURL, { method: 'PUT', data: action.data, headers: HTTP_HEADERS });
        yield put(EWSAction.publishUnpublishEWSReportResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.publishUnpublishEWSReportResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* publishUnpublishEWSReport() {
    yield takeLatest(EWSAction.PUBLISH_UNPUBLISH_EWS_REPORT_REQUEST, publishUnpublishEWSReportRequest);
}

export function* bulkCrawlerStatusReportRequest(action) {
    let requestURL = `${EWS_API}/run/bulkCrawlerStatus?fromDate=${action.data.fromDate}&toDate=${action.data.toDate}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.bulkCrawlerStatusResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.bulkCrawlerStatusResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* bulkCrawlerStatusReport() {
    yield takeLatest(EWSAction.BULK_CRAWLER_STATUS_REQUEST, bulkCrawlerStatusReportRequest);
}

export function* getPublishListRequest(action){
    let requestURL = `${EWS_API}/publish`;
    
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.getPublishListResponse({ data : data.data , status : "SUCCESS"}))
    }catch (err) {
        yield put(EWSAction.getPublishListResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* getPublishList() {
    yield takeLatest(EWSAction.GET_PUBLISH_LIST_REQUEST, getPublishListRequest);
}

export function* deletePublishRequest(action){
    let requestURL = `${EWS_API}/publish?publishId=${action.data.publishId}`;
    
    try {
        const data = yield call(request, requestURL, { method: 'DELETE', headers: HTTP_HEADERS });
        yield put(EWSAction.deletePublishResponse({ data : data.data , status : "SUCCESS"}))
    }catch (err) {
        yield put(EWSAction.deletePublishResponse( { ...err.response , status : "FAILURE"}))
    }
}

export function* deletePublish() {
    yield takeLatest(EWSAction.DELETE_PUBLISH_REQUEST, deletePublishRequest);
}

export function* downloadEWSReportByDateRequest(action) {
    let requestURL = `${CORE_API}/ews/report/byDateRange?fromDate=${action.data.fromDate}&toDate=${action.data.toDate}&isPortfolio=${action.data.isPortfolio}`;
    try {
        const data = yield call(request, requestURL, { method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.downloadEWSReportByDateResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.downloadEWSReportByDateResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* downloadEWSReportByDate() {
    yield takeLatest(EWSAction.DOWNLOAD_EWS_REPORT_BY_DATE_REQUEST, downloadEWSReportByDateRequest);
}

export function* sendEWSIndividualMailRequest(action) {
    let requestURL = `${EWS_API}/publish/individualMail?publishId=${action.data.publishId}&corporateId=${action.data.corporateId}`;
    try {
        const data = yield call(request, requestURL, { method: 'POST', headers: HTTP_HEADERS });
        yield put(EWSAction.sendEWSIndividualMailResponse({ data : data.data , status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.sendEWSIndividualMailResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* sendEWSIndividualMail() {
    yield takeLatest(EWSAction.SEND_EWS_REPORT_INDIVIDUAL_MAIL_REQUEST, sendEWSIndividualMailRequest);
}

export function* ewsReportFinancialRequest(action) {
    let requestURL = `${CORE_API}/ews/financial`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('isPortfolio', action.data.isPortfolio);
    try {
        const data = yield call(request, requestURL, {  method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER });
        yield put(EWSAction.ewsReportWithFinancialResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsReportWithFinancialResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsReportWithFinancial() {
    yield takeLatest(EWSAction.EWS_REPORT_FINANCIAL_REQUEST, ewsReportFinancialRequest);
}

export function* ewsTodoOptinSchedulerRequest(action) {
    let requestURL = `${EWS_API}/ews/todoOptinScheduler`;
    try {
        const data = yield call(request, requestURL, {  method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.ewsTodoOptinSchedulerResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsTodoOptinSchedulerResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsTodoOptinScheduler() {
    yield takeLatest(EWSAction.EWS_TODO_OPTIN_SCHEDULER_REQUEST, ewsTodoOptinSchedulerRequest);
}

export function* ewsOptedOutReportRequest(action) {
    let requestURL = `${EWS_API}/ews/optout/excel`;
    try {
        const data = yield call(request, requestURL, {  method: 'GET', headers: HTTP_HEADERS });
        yield put(EWSAction.ewsOptedOutReportResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsOptedOutReportResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsOptedOutReport() {
    yield takeLatest(EWSAction.EWS_OPTED_OUT_REPORT_REQUEST, ewsOptedOutReportRequest);
}

export function* ewsCorporateNamesDownloadRequest(action) {
    let requestURL = `${EWS_API}/publish/corporates/excel?publishId=${action.data.publishId}`;
    try {
        const data = yield call(request, requestURL, {  method: 'GET', headers: HTTP_HEADERS, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER});
        yield put(EWSAction.ewsCorporateNamesDownloadResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsCorporateNamesDownloadResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsCorporateNamesDownload() {
    yield takeLatest(EWSAction.EWS_CORPORATE_NAMES_DOWNLOAD_REQUEST, ewsCorporateNamesDownloadRequest);
}


export function* ewsCorporateNamesUploadRequest(action) {
    let requestURL = `${EWS_API}/publish/update`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('publishId', action.data.publishId);
    try {
        const data = yield call(request, requestURL, {  method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA});
        yield put(EWSAction.ewsCorporateNamesUploadResponse({ data: data, status: "SUCCESS" }))
    }
    catch (err) {
        yield put(EWSAction.ewsCorporateNamesUploadResponse({ ...err.response, status: "FAILURE" }))
    }
}

export function* ewsCorporateNamesUpload() {
    yield takeLatest(EWSAction.EWS_CORPORATE_NAMES_UPLOAD_REQUEST, ewsCorporateNamesUploadRequest);
}